interface Halls{
    id: number,
    title: string,
    address: string,
    image: string,
    phone: string,
    map: string,
}

const halls: Halls[] = [
    {
        id: 0,
        title: 'бул. вечірній',
        address: 'бул. Вечірній 18а',
        image: '../../assets/crossgym1.jpg',
        phone: '068-655-00-69',
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6878.009274345891!2d33.428833977430365!3d47.9401562294656!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40db206eda5c17a3%3A0x1346963703376ed9!2z0KTQuNGC0L3QtdGBINC60LvRg9CxIENyb3NzR1lN!5e0!3m2!1sru!2sua!4v1704975796430!5m2!1sru!2sua"
    },
    {
        id: 1,
        title: 'соцмісто',
        address: 'вул. Степана Тільги 16',
        image: '../../assets/crossgym1.jpg',
        phone: '068-655-00-99',
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d38929.24565334862!2d33.32686409430991!3d47.91177889645059!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40db21eaeb6fd345%3A0x64a040ac794fe7fd!2z0YTQuNGC0L3QtdGBINC60LvRg9CxIENyb3NzR1lNINGB0L7RhtCz0L7RgNC-0LQg0LrQvtGB0LzQvtGB!5e0!3m2!1sru!2sua!4v1704977523785!5m2!1sru!2sua"
    },
    {
        id: 2,
        title: 'східний-2',
        address: 'вул. Сахарова 17а',
        image: '../../assets/crossgym1.jpg',
        phone: '098-655-00-99',
        map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d668.1355559506421!2d33.45153325014967!3d47.94523800000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40db2145c2afd837%3A0x26b8953670c2e8cc!2scrossgim!5e0!3m2!1sru!2sua!4v1704977599432!5m2!1sru!2sua"
    },
]

export default halls;